import clsx from "clsx";
import { AnchorHTMLAttributes, DetailedHTMLProps, FC } from "react";
import { NewsIcon } from "./NewsIcon";
import { PlayIcon } from "./PlayIcon";
import { PodcastIcon } from "./PodcastIcon";

export type ICON_TYPE = "podcast" | "video" | "article";

type Props = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> & {
  type: ICON_TYPE;
};

export const IconLink: FC<Props> = ({ type, ...props }) => {
  const className = "fill-current text-primary h-12 w-12";
  return (
    <a
      {...props}
      className={clsx(
        props.className,
        "text-white border rounded-full w-19 h-19 aspect-square bg-white border-1 border-primary shadow-md flex items-center justify-center",
        props.className
      )}
      aria-label={`${type} icon`}
    >
      {type === "podcast" && (
        <PodcastIcon className={clsx(className, "mt-0.5")} />
      )}
      {type === "video" && (
        <PlayIcon className={clsx(className, "stroke-current")} />
      )}
      {type === "article" && <NewsIcon className={className} />}
    </a>
  );
};
